/**
 * File: contentListing.js.
 *
 *
 */

import card from '../elements/card';

const $ = require('jquery');

export default {
  cardsWrapper: document.querySelector('[data-filter=content-cards]'),
  searchWrapper: document.querySelector('[data-filter=search-results]'),
  // eslint-disable-next-line no-undef
  ajaxUrl: wpAjax.ajax_url,
  init() {
    if (this.cardsWrapper || this.searchWrapper) {
      this.render();
    }
  },
  ajaxCall() {
    const data = $('[data-js-form=filter]').serialize();
    $.ajax({
      url: this.ajaxUrl,
      data,
      type: 'post',
      success: (result) => {
        if ('[data-filter=content-cards]') {
          $('[data-filter=content-cards]').html(result);
          card.init();
        }
        if ($('[data-filter=search-results]')) {
          $('[data-filter=search-results]').html(result);
        }
      },
      error: (result) => {
        // eslint-disable-next-line no-console
        console.warn(result);
      },
    });
  },
  checkQueryParam() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const [ $type ] = $('.js-dropdown-type');
    const [ $order ] = $('.js-dropdown-order');
    const [ $cat ] = $('.js-dropdown-category');

    if (Object.keys(params).length !== 0) {
      if (params.type && params.type !== '') {
        const contentType = document.querySelector('#content-post-type');
        contentType.value = params.type;
        $type.dataset.value = params.type;
        $type.innerHTML = params.type;
      }
      if (params.order && params.order !== '') {
        const contentOrder = document.querySelector('#content-order');
        $order.dataset.value = params.order;
        contentOrder.value = params.order;
        switch (params.order) {
        case 'ASC':
          $order.innerHTML = 'Oldest';
          break;
        case 'DESC':
          $order.innerHTML = 'Newest';
          break;
        default:
          $order.innerHTML = 'Oldest';
        }
      }
      if (params.category && params.category !== '') {
        const contentCat = document.querySelector('#content-category');
        $cat.dataset.value = params.category;
        contentCat.value = params.category;
        const list = document.querySelectorAll('[data-dropdown=dropdown-2] li');
        const selected = [ ...list ].find((item) => item.firstChild.dataset.value === params.category);
        $cat.innerHTML = selected.firstChild.innerHTML;
      }
    }
  },
  render() {
    const $dropdown = $('.js-filter-dropdown');
    const $select = $('.js-filter-dropdown-selected');

    if (this.cardsWrapper) {
      this.checkQueryParam();
    }

    $.each($select, (i, item) => {
      $(item).on('click', (e) => {
        e.preventDefault();

        // remove active class to other dropdown
        $.each($dropdown, (num, list) => {
          if (num !== i) {
            $(list).find('button.active-dropdown').removeClass('active-dropdown');
            $(list).find('ul.dropdown-visible').removeClass('dropdown-visible');
          }
        });

        // add active class to active dropdown
        $(`[data-dropdown=dropdown-${ i }]`).toggleClass('dropdown-visible');
        $(item).toggleClass('active-dropdown');

        // get each button on ul
        const $options = $(`[data-dropdown=dropdown-${ i }] button`);
        const input = $(`.js-filter-input-${ i }`);
        $.each($options, (index, option) => {
          if (option.clickSet) return;

          $(option).on('click', (event) => {
            event.preventDefault();
            $(item).attr('data-value', option.dataset.value);
            $(item).text(option.innerText);
            $(input).val(option.dataset.value);

            // removes active classes to button and ul when an option is selected
            $(`[data-dropdown=dropdown-${ i }]`).removeClass('dropdown-visible');
            $(item).removeClass('active-dropdown');

            // call ajax function
            this.ajaxCall();
          });

          option.clickSet = true;
        });
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
